import React from 'react';
import { Loader } from 'lucide-react';

const AIProcessor = ({ onProcess, isProcessing, onClose }) => {
    const [input, setInput] = React.useState('');

    const handleProcess = () => {
        if (input.trim()) {
            onProcess(input);
            setInput('');
        }
    };

    return (
        <div className="mb-6 p-4 bg-gradient-primary/10 border border-accent/20 rounded-lg slide-in">
            <h3 className="text-sm font-semibold text-white mb-3 flex items-center gap-2">
                <span className="text-xl">✨</span>
                AI Task Improvement
            </h3>
            <p className="text-xs text-white/60 mb-3">
                Enter a simple note and let AI expand it into a structured task with subtasks and suggestions.
            </p>

            {isProcessing ? (
                <div className="flex items-center justify-center py-8">
                    <Loader className="animate-spin text-accent" size={32} />
                    <span className="ml-3 text-white/70">AI is analyzing your task...</span>
                </div>
            ) : (
                <>
                    <textarea
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                        placeholder="e.g., 'organize team meeting next week'"
                        className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-lg text-white placeholder-white/40 focus:outline-none focus:border-accent transition-colors resize-none"
                        rows={3}
                    />
                    <div className="flex gap-2 mt-3">
                        <button
                            type="button"
                            onClick={handleProcess}
                            className="flex-1 btn-primary text-sm"
                        >
                            Improve Task
                        </button>
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-4 py-2 bg-white/5 hover:bg-white/10 border border-white/10 rounded-lg text-white text-sm transition-colors"
                        >
                            Cancel
                        </button>
                    </div>
                </>
            )}
        </div>
    );
};

export default AIProcessor;
